// NO SYSTEM ID ON SCREEN (owner rule, 29 Sep 2026).
//
// "No id may be shown anywhere. Only the id the hospital gives to the patient
// is shown." Generated business keys — TN00001, MOC00008, DOC00012, TTY00001,
// APT00031 — stay in route params, API payloads, React keys and test ids, but
// never in what a person reads.
//
// Most call sites simply stop drawing the id field. This helper is for the few
// places that fall back to a stored VALUE which is sometimes a readable slug
// (a seeded tenant type 'hospital') and sometimes a generated id ('TTY00001'):
// the slug may still be shown, the id may not.
export const looksLikeSystemId = (value) =>
    typeof value === 'string' && /^[A-Z]{2,}\d+$/.test(value.trim());

// The value itself when it is safe to draw, otherwise `fallback`.
export const unlessSystemId = (value, fallback = null) =>
    (value == null || value === '' || looksLikeSystemId(value) ? fallback : value);
